import simpleSoilAttribute from './simpleSoilAttribute';

export const DEPTH_TO_WATER_TABLE = simpleSoilAttribute({
  key: 'Depth to Water Table',
  ratingCol: {
    displayString: 'Depth (cm)',
    accessor: 'mapUnitRatingString',
  },
  ruleId: '82',
  shortFormData: {
    BeginningMonth: 'January',
    EndingMonth: 'December',
    TiebreakRule: '-1',
  },
  units: 'cm',
});
